// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c82702f1","455":"3a7f86ac","977":"c06a7241"}[chunkId] + ".chunk.js";
};